module.exports = __webpack_public_path__ + "static/media/photo.d6cbd8e6.png";